import React, { useState } from 'react';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import { BsEye, BsEyeSlash } from 'react-icons/bs';

/**
 * Un mot de passe qu'on peut relire.
 *
 * Saisir huit caractères à l'aveugle sur un téléphone est la première cause
 * d'échec de connexion. Le rendre visible d'un doigt évite le troisième essai
 * et le mot de passe « oublié » qui n'est pas oublié.
 */
export default function ChampMotDePasse({ label = 'Mot de passe', ...reste }) {
  const [visible, setVisible] = useState(false);

  return (
    <TextField
      {...reste}
      label={label}
      type={visible ? 'text' : 'password'}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={() => setVisible((v) => !v)}
              edge="end"
              tabIndex={-1}
              aria-label={visible ? 'Masquer le mot de passe'
                                  : 'Afficher le mot de passe'}
            >
              {visible ? <BsEyeSlash /> : <BsEye />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}
